export default __webpack_public_path__ + "9b36f645ea0ec5cf848b68f20626d6de.svg";